import { createSlice } from '@reduxjs/toolkit';
import { ICsaDashboard } from '../types';

const initialState: ICsaDashboard = {
  csaDetails: {
    data: {},
    loading: false
  },
  dmeDetails: {
    data: {},
    loading: false
  },
  caseRecommendationStatsLoading: false
};

const csaPerformanceDashboardSlice = createSlice({
  name: 'csaPerformanceDashboard',
  initialState,
  reducers: {
    setCsaDetails: (state, action) => {
      state.csaDetails.data = action.payload;
    },
    setCsaDetailsLoading: (state, action) => {
      state.csaDetails.loading = action.payload;
    },
    setDmeDetails: (state, action) => {
      state.dmeDetails.data = action.payload;
    },
    setDmeDetailsLoading: (state, action) => {
      state.dmeDetails.loading = action.payload;
    },
    setCaseRecommendationStatsLoading: (state, action) => {
      state.caseRecommendationStatsLoading = action.payload;
    }
  }
});

export const {
  setCsaDetails,
  setCsaDetailsLoading,
  setDmeDetails,
  setDmeDetailsLoading,
  setCaseRecommendationStatsLoading
} = csaPerformanceDashboardSlice.actions;

export default csaPerformanceDashboardSlice.reducer;
